/**
 * export uri dùng đẻ call API
 */
export const uriAPIConsts = {

  chat: {
    FACEBOOK: {
      SUBSCRIBE_APP: '/chat/facebook/subscribedapp',
      GET_TOKEN_INFO: '/chat/facebook/gettokeninfo',
    }
  },
  user: {
    OUT_PAGE: '/user/outpages'
  },
  login: {
    LIST_PAGE: '/user/pagelist', // lấy danh sách page khi login
    LOAD_MORE_PAGE_META: '/user/loadmorepagemeta',
    USER_JOIN_PAGES: '/user/joinpages',
  },
  notification: {
    SUBSCRIBE_TO_TOPICS: '/notification/subscribetotopics',
    UNSUBSCRIBE_FROM_ALL_TOPICS: '/notification/unsubscribefromalltopics'
  },
  business: {
    SETTING2: '/business/index/setting2'
  }
}
